import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'svc-validation-message',
  templateUrl: './svc-validation-message.component.html',
  styleUrls: ['./svc-validation-message.component.scss'],
  providers: [DatePipe],
})
export class SvcValidationMessageComponent {
  private _validationMessage: any = {};
  @Input() control!: AbstractControl | null;
  @Input() showWhenDirty: boolean = true;

  constructor(
    private _datePipe: DatePipe,
    private _translocoService: TranslocoService
  ) {}

  get validationMessage(): { message: string } {
    const control = this.control;
    if (!control) {
      return null;
    }

    const canShow = this.showWhenDirty ? control.dirty || control.touched : control.touched;
    if (!canShow) {
      return null;
    }

    for (let validator in control.errors) {
      if (control.errors.hasOwnProperty(validator)) {
        this._validationMessage = this.formatValidationMessage(validator, control.errors[validator]);
        return this._validationMessage;
      }
    }
    return null;
  }

  private translate(text: string) {
    return this._translocoService.translate(text);
  }

  private formatValidationMessage(validator: string, value: any): any {
    const validationMessages = {
      error: () => ({ message: this.translate('O campo está com erro') }),
      required: () => ({ message: this.translate('Campo obrigatório') }),
      duplicated: () => ({ message: this.translate('Nome duplicado') }),
      mustMatch: () => ({ message: this.translate('As senhas devem ser iguais') }),
      invalidDate: () => ({ message: this.translate('Data inválida') }),
      minDate: (value: { date: Date; format: string }) => ({
        message: `${this.translate('A data deve ser maior ou igual a')} ${this._datePipe.transform(value.date, value.format)}`,
      }),
      maxDate: (value: { date: Date; format: string }) => ({
        message: `${this.translate('A data deve ser menor ou igual a')} ${this._datePipe.transform(value.date, value.format)}`,
      }),
      maxlength: (value: { requiredLength: number }) => ({ message: `${this.translate('O conteúdo deve conter o número máximo de caracteres')}: ${value.requiredLength}` }),
      minlength: (value: { requiredLength: number }) => ({ message: `${this.translate('O conteúdo deve conter o número mínimo de caracteres')}: ${value.requiredLength}` }),
      max: (value: { max: number }) => ({ message: `${this.translate('O valor máximo é')}: ${value.max}` }),
      min: (value: { min: number }) => ({ message: `${this.translate('O valor mínimo é')}: ${value.min}` }),
      spaceNotAllowed: () => ({ message: this.translate('O campo não pode conter espaços') }),
      invalid24Hour: () => ({ message: `${this._translocoService.translate('Insira um horário válido no formato HH:MM')}` }),
      invalidDecimalPlaces: () => ({ message: this.translate('O campo deve conter no máximo 6 casas decimais') }),
      selectPeriodMaxRange: () => ({ message: this.translate('Limite de pesquisa 1 ano') }),
    };
    return validationMessages.hasOwnProperty(validator) ? validationMessages[validator](value) : validationMessages.error();
  }
}



